import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 90vh;
`;

const OccasionsList = styled.div`
  display: grid !important;
  gap: 24px;
  grid-template-columns: repeat(4, minmax(234px, 1fr));
  margin-bottom: 24px;
`;

const OccasionItem = styled.div`
  align-items: center;
  aspect-ratio: 133/109;
  background: var(--color-bg-default, #fff);
  border: 1px solid var(--color-border-default, #e5e8ef);
  border-radius: var(--size-border-radius-md, 4px);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: var(--size-gap-8);
  padding: var(--size-padding-16);
  position: relative;
  text-align: center;
`;

const ContentInner = styled.div``;

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  flex-shrink: 0;
  gap: var(--size-padding-24);
  padding: var(--size-page-padding-xs) 0 0 0;
`;
const Header = styled.div`
  align-items: center;
  display: flex;
  height: 64px;
  justify-content: space-between;
`;
const HeadRight = styled.div``;
const HeadLeft = styled.div``;
const Head = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CreateWithAIButton = styled.button`
  background: #632ee4;
  border: 2px solid #fff;
  border-radius: var(--size-border-radius-circle, 1224px);
  box-shadow:
    0px 2px 20px 0px rgba(164, 108, 244, 0.2),
    0px 2px 12px 0px rgba(200, 178, 255, 0.7) inset;
  color: var(--color-fg-inverse-default, #fff);
  cursor: pointer;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  height: 32px;
  width: 140px;
`;

export {
  Content,
  ContentInner,
  CreateWithAIButton,
  Head,
  HeadLeft,
  HeadRight,
  Header,
  OccasionItem,
  OccasionsList,
  Wrapper
};
